import pkdApi from 'store/api/pkd';

const handlePersonAttributes = ({ data }) => data.map(item=>({ ...item.attributes, id: item.id }));

const personApi = pkdApi.injectEndpoints({
  endpoints : (build) => ({
    updatePerson : build.mutation({
      query : ({ body, personId }) => ({
        url    : `/site/1/persons/${personId}?include=person_attribute`,
        method : 'PATCH',
        body,
      }),
      invalidatesTags : ['User'],
    }),
    createPerson : build.mutation({
      query : ({ attributes }) => ({
        url    : '../v3/people',
        method : 'POST',
        body   : {
          data : {
            type : 'people',
            attributes,
          },
        },
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
    }),
    updateV3Person : build.mutation({
      query : ({ attributes, personId }) => ({
        url    : `../v3/people/${personId}`,
        method : 'PATCH',
        body   : {
          data : {
            type : 'people',
            id   : personId,
            attributes,
          },
        },
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
      invalidatesTags : ['Person'],
    }),
    createPersonUser : build.mutation({
      query : ({ attributes }) => ({
        url    : '../v3/users',
        method : 'POST',
        body   : {
          data : {
            type : 'users',
            attributes,
          },
        },
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
      invalidatesTags : ['CurrentPerson'],
    }),
    createPersonAttribute : build.mutation({
      query : ({ attributes, personId }) => ({
        url    : `../v3/people/${personId}/attributes`,
        method : 'POST',
        body   : {
          data : {
            type : 'person-attributes',
            attributes,
          },
        },
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
      invalidatesTags : ['PersonAttributes'],
    }),
    upsertPersonAttribute : build.mutation({
      query : ({ body, personId }) => ({
        url     : `../v3/app/people/${personId}/attributes`,
        method  : 'PATCH',
        body,
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
      invalidatesTags : ['PersonAttributes'],
    }),
    currentPersonUser : build.query({
      query : () => ({
        url     : '../v3/users/current?include=person',
        method  : 'GET',
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
      providesTags : ['CurrentPerson'],
    }),
    getPersonById : build.query({
      query : ({ personId }) => ({
        url     : `../v3/people/${personId}`,
        method  : 'GET',
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
      providesTags : ['Person'],
    }),
    getPersonAttributes : build.query({
      query : ({ personId }) => ({
        url     : `../v3/people/${personId}/attributes?page[limit]=100`,
        method  : 'GET',
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
      providesTags      : ['PersonAttributes'],
      transformResponse : handlePersonAttributes,
    }),
    getPersonStudyRoles : build.query({
      query : ({ personId }) => ({
        url     : `../v3/people/${personId}/study-roles`,
        method  : 'GET',
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
      providesTags : ['PersonStudyRoles'],
    }),
    createPersonStudyRole : build.mutation({
      query : ({ attribute }) => ({
        url    : `../v3/people/${attribute.personId}/study-roles`,
        method : 'POST',
        body   : {
          data : {
            type       : 'person-study-roles',
            attributes : {
              ...attribute,
              siteId : 1,
            },
          },
        },
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
      invalidatesTags : ['PersonStudyRoles'],
    }),
    createProfile : build.mutation({
      query : ({ attributes }) => ({
        url    : '../v3/app/profiles',
        method : 'POST',
        body   : {
          data : {
            type : 'profiles',
            attributes,
          },
        },
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
      invalidatesTags : ['CurrentProfile'],
    }),
    getPersonAccountProfile : build.query({
      query : ({ personId }) => ({
        url     : `../v3/people/${personId}/account-profiles`,
        method  : 'GET',
        headers : {
          'Content-Type' : 'application/vnd.api+json',
          Accept         : 'application/vnd.api+json',
        },
      }),
      providesTags : ['PersonAccountProfile'],
    }),
  }),
  overrideExisting : false,
});

export const {
  useUpdatePersonMutation,
  useCreatePersonMutation,
  useCreatePersonUserMutation,
  useCreatePersonAttributeMutation,
  useUpsertPersonAttributeMutation,
  useCreatePersonStudyRoleMutation,
  useUpdateV3PersonMutation,
  useCurrentPersonUserQuery,
  useGetPersonAttributesQuery,
  useGetPersonByIdQuery,
  useGetPersonStudyRolesQuery,
  useCreateProfileMutation,
  useGetPersonAccountProfileQuery
} = personApi;
